import React, { useState, useEffect } from 'react';
import Loading from './Loading'
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import { numberFormat } from './Investor'




function DataFeed(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Invest with the best";
    const [pageData, setpageData] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/data-feed?days=15&access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        setpageData(cdresponse.data)
    }
    const getUrl = (url) => {
        return "/Company/" + url
    }
    

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    

    useEffect(() => {
        companyDetails()
    }, [])


    return (
        <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "14px", minHeight: "650px", marginLeft: "10px", marginRight: "10px", paddingBottom: "110px", paddingTop: "90px" }}>
            
            <div>
                {Object.keys(pageData).length > 0 &&
                    <div style={{ padding: "10px 110px 30px 110px" }}><div className="AboutHeaderTop" style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                        <div className="SuperHeader" style={{ textAlign: "left", padding: "10px 5px", fontSize: "20px", fontWeight: "600" }}>
                            Shareholding pattern filed by companies in the last 15 days.
                            </div>
                        </div>
                        <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "10px", maxWidth:"900px"}}>
                            
                            <table className="PeersTable finData" style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td className="columnHeading" style={{whiteSpace: "nowrap", textAlign: "left", paddingLeft: "10px", fontWeight: "500" }}>Company Name</td>
                                        <td className="columnHeading" style={{whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>Symbol</td>
                                        <td className="columnHeading" style={{whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>Quarter</td>
                                    <td className="columnHeading" style={{ textAlign: "left", paddingLeft: "10px", whiteSpace: "nowrap", textAlign: "center", fontWeight: "500" }}>Broadcast Date</td>
                                    </tr>
                                </tbody>
                                <tbody>
                                {pageData.data.map((dataKey, index) => (
                                    <tr>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ minWidth: "150px", whiteSpace: "nowrap", textAlign: "left" }}>{dataKey.company_name}</td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{minWidth:"150px", whiteSpace: "nowrap", textAlign: "center", paddingLeft: "10px" }}><a href={getUrl(dataKey.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{dataKey.stock_symbol}</a></td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ minWidth: "150px", whiteSpace: "nowrap", textAlign: "center" }}>{dataKey.quarter}</td>
                                        <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ minWidth: "150px", whiteSpace: "nowrap", textAlign: "center" }}>{dataKey.broadcast_date_str}</td>
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>

                }
                {Object.keys(pageData).length === 0 &&
                    <div style={{ minHeight: "400px", paddingTop: "180px" }}>
                        <Loading />
                    </div>
                }

            </div>
        </div>
    );
}
export default DataFeed;

